import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ChakraProvider } from '@chakra-ui/react'
import {BrowserRouter} from "react-router-dom"
import CartContextProvider from "./Components/Context/CartContext/CartContextProvider"
import { AppContextProvider } from './Components/Pages/AppContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ChakraProvider>
    {/* <AuthContextProvider> */}
      <CartContextProvider>
        <AppContextProvider>

      
        <BrowserRouter>
          <App />
        </BrowserRouter>
        </AppContextProvider>
      </CartContextProvider>
    {/* </AuthContextProvider> */}
  </ChakraProvider>
  
    
  
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
